import MatchMedia from '../utils/matchMedia';

export default class CarouselPartner {
    constructor() {
        this.matchMedia = new MatchMedia();
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            myCarouselPartnerBtn: document.querySelectorAll(".partner-carousel__rotation")
        }
    }

    listen() {
        if(this.ui.myCarouselPartnerBtn.length > 0) {
            this.ui.myCarouselPartnerBtn.forEach((item) => { // Pour chaque bouton de carousel partner
                item.addEventListener("click",() => { // Au click sur le bouton de contrôle
                    const myCarouselPartner = item.closest(".partner-carousel").querySelector('.partner-carousel__items-holder'); // DOM du slider
                    if(item.classList.contains("play")) { // Démarrer le slider
                        item.classList.remove("play");
                        item.classList.add("pause");
                        myCarouselPartner.classList.remove('pause');
                        myCarouselPartner.setAttribute('aria-live', 'off');
                    } else { // Arrêter le slider
                        myCarouselPartner.classList.add('pause');
                        myCarouselPartner.setAttribute('aria-live', 'polite');
                        item.classList.remove("pause");
                        item.classList.add("play");
                    }
                });
            });
        }
    }
}